import { render, staticRenderFns } from "./ResultsPDFDetails.vue?vue&type=template&id=5928e536"
import script from "./ResultsPDFDetails.vue?vue&type=script&lang=js"
export * from "./ResultsPDFDetails.vue?vue&type=script&lang=js"
import style0 from "./ResultsPDFDetails.vue?vue&type=style&index=0&id=5928e536&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports